// frontend/src/components/Portfolio.jsx
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './Portfolio.css';

const INITIAL_VISIBLE_PROJECTS = 2;
const Portfolio = ({ portfolioData }) => {
  const { t } = useTranslation();


  const [visibleCount, setVisibleCount] = useState(INITIAL_VISIBLE_PROJECTS);

  if (!portfolioData || !Array.isArray(portfolioData) || portfolioData.length === 0) {
    return (
      <section id="portfolio" className="portfolio-section">
        <h2>{t('portfolio.title')}</h2>
        {/* Можно использовать ключ из portfolio.json */}
        <p>{t('portfolio.emptyMessage', 'Проекты на этом языке скоро появятся.')}</p>
      </section>
    );
  }

  const isExpanded = visibleCount === portfolioData.length;
  const visibleProjects = portfolioData.slice(0, visibleCount);

  const handleToggleVisibility = () => {
    if (isExpanded) {
      setVisibleCount(INITIAL_VISIBLE_PROJECTS);
    } else {
      setVisibleCount(portfolioData.length);
    }
  };

  return (
    <section id="portfolio" className="portfolio-section">
      <h2>{t('portfolio.title')}</h2>
      <div className="portfolio-grid">
        {visibleProjects.map((item) => (
          <div key={item.id} className="portfolio-item">
            {item.image_url && <img src={item.image_url} alt={item.title} loading="lazy" />}
            {item.title && <h3>{item.title}</h3>}
            {item.description && <p>{item.description}</p>}

            {item.project_url && (
              <a href={item.project_url} target="_blank" rel="noopener noreferrer" className="button">
                {t('portfolio.item.viewProjectButton')}
              </a>
            )}
            {item.github_url && (
              <a href={item.github_url} target="_blank" rel="noopener noreferrer" className="button">
                {t('portfolio.item.viewCodeButton')}
              </a>
            )}
          </div>
        ))}
      </div>

      {portfolioData.length > INITIAL_VISIBLE_PROJECTS && (
        <div className="show-more-container" style={{ textAlign: 'center', marginTop: '30px' }}>
          <button onClick={handleToggleVisibility} className="show-more-button">
            {isExpanded
              ? t('portfolio.showLessButton', 'Свернуть проекты')
              : t('portfolio.showMoreButton', 'Показать все проекты')}
          </button>
        </div>
      )}
    </section>
  );
};

export default Portfolio;
